import axios from 'axios';
import { getStoredSessionToken } from './sessionTokens';
import { resolveChatBaseUrl } from './runtimeConfig';

export const liveChatBaseUrl = resolveChatBaseUrl();

export const liveChatWsBaseUrl = liveChatBaseUrl
  .replace(/^https:\/\//, 'wss://')
  .replace(/^http:\/\//, 'ws://');

const liveChatApi = axios.create({
  baseURL: liveChatBaseUrl,
});

liveChatApi.interceptors.request.use((config) => {
  const token = getStoredSessionToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const uploadUrl = () => `${liveChatBaseUrl}/api/chat/uploads`;

export const uploadLiveChatPhoto = async (file) => {
  if (!file || Number(file.size || 0) <= 0) {
    throw new Error('The selected photo is empty. Choose the photo again.');
  }

  const form = new FormData();
  form.append('file', file, file.name || 'chat-photo');

  const token = getStoredSessionToken();
  const headers = { Accept: 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;

  // Native fetch owns the multipart boundary. Some Android WebViews kept a
  // bare Axios multipart header even after it was deleted by an interceptor.
  const response = await fetch(uploadUrl(), {
    method: 'POST',
    headers,
    body: form,
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    // Keep the user-facing fallback below when a proxy returns non-JSON.
  }

  if (!response.ok || !payload?.attachment?.id) {
    const error = new Error(payload?.detail || 'Photo upload failed. Please choose the photo again.');
    error.response = { status: response.status, data: payload };
    throw error;
  }

  return payload.attachment;
};

export default liveChatApi;
